import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { AvatarHeadStyle1 } from './Style1'
import { AvatarHeadStyle2 } from './Style2'
import { AvatarHeadStyle3 } from './Style3'

export const NAME = 'head'
export const STYLES = {
  style1: AvatarHeadStyle1,
  style2: AvatarHeadStyle2,
  style3: AvatarHeadStyle3
}
export const INLINE_STYLE = {
  width: '220%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-5%)'
}
export const AvatarHead = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, 'body.colors', [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color?.colors

  return (
    <AvatarPieceBase
      {...rest}
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
    />
  )
}
